<template>
    <div class="kgk-global-progress embedded-progress">
        <div v-if="goal && !loading">
            <!--div id="confetti"></div-->
            <Progress :radius="30" :strokeWidth="10" :value="progress" :strokeColor="'#82C800'" :staticProgress="staticProgress">
                <template v-slot:footer>
                    <h3>{{ convertNumberReadable(Math.round(total * 10) / 10) }} / {{ convertNumberReadable(goal,10) }} km</h3>
                    <!--<h1>Gesamtergebnis 154.737</h1>-->
                </template>
            </Progress>
        </div>
        <div v-else-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">FEHLER</div>
    </div>
</template>

<script>
    import runs from '../api/runs';
    import Progress from './easy-circular-progress-embed/index';
    //import JSConfetti from 'js-confetti';

    //const jsConfetti = new JSConfetti();

    export default {
        name: 'GlobalProgress',
        props: {
            //msg: String
        },
        data() {
            return {
                total: null,
                goal: null,
                staticProgress: null,
                loading: false,
                error: null,
                overflow:0,
                textData:'...',
                confettiCounter:0,
            }
        },
        computed: {
            progress: function() {

                return this.goal ? (Math.round(this.total / this.goal * 100 * 10) / 10) : 0;
            },
        },
        methods: {
            calculateProgress() {
                
                
            },
            winnerAnimation(){

                jsConfetti.addConfetti({
                    confettiColors: [
                        '#82C800', 'rgb(0, 147, 161)'
                    ],
                    confettiRadius: 6,
                    confettiNumber: 60,
                }).then(() => {
                    if(this.confettiCounter <= 4){
                        this.confettiCounter++;
                        this.winnerAnimation();
                    }
                }
                );
            }
        },
        mounted() {
            this.loading = true;

            

            runs.getTotal(
                this,
                data => {
                    this.total = data.total;
                    this.goal = data.goal;
                    this.staticProgress = data.static.map(data => {
                        this.total += data.value;
                        data.percentage = data.value / this.goal;
                        return data;
                    });
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );

        },
        components: {
            Progress
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$circular-progress-int-fz: 32px;
    #apponline .kgk-global-progress__notice p,
    .kgk-app .kgk-global-progress__notice p,
    .kgk-global-progress__notice {
        font-weight: 100;
        max-width: 200px;
        margin: 10px auto 0 auto;
    }
    .embedded-progress .vue-circular-progress {
        font-size:10px;
    }
    .embedded-progress .percent span{
        font-size:14px!important;
    }
    .embedded-progress .percent__int{
        font-size:14px!important;
    }
    .embedded-progress .vue-circular-progress h1, 
    .embedded-progress .vue-circular-progress h3, {
        font-size:10px;

    }
    .embedded-progress .vue-circular-progress h3 {
        margin: 0;
    }
</style>
